import { Heading, Text } from '@lmc/ui-kit/src/general'
import { Trans, useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import PaywallIcon from '../../siteSettings/components/SettingsPaywall/PaywallIcon'
import LmcBackgroundLogo from '../../siteSettings/components/SettingsPaywall/LmcBackgroundLogo'
import { RightOutlined } from '@ant-design/icons'
import { useState } from 'react'
import RotaPaywallModal from './RotaPaywallModal'
import useHomeType from 'hooks/useHomeType'

const RotaPaywall = () => {
  const { alreadyHadRotaTrialEnabled } = useHomeType()

  const [showModal, setShowModal] = useState(false)

  const { t } = useTranslation()

  return (
    <Container>
      <TopContainer>
        <LeftContainer>
          <Heading level={1}>{t('ROTA_PAYWALL_TITLE')}</Heading>
          <TextContainer>
            <Text>{t('ROTA_PAYWALL_SUBTITLE')}</Text>
            {!alreadyHadRotaTrialEnabled && (
              <CustomCta onClick={() => setShowModal(true)}>
                <Text weight="bold" level={1}>
                  {t('ROTA_PAYWALL_CTA')}
                </Text>
                <UnderlinedText weight="bold" level={1}>
                  {t('ROTA_PAYWALL_FREE_TRIAL')}
                </UnderlinedText>
                <RightOutlined />
              </CustomCta>
            )}
          </TextContainer>
        </LeftContainer>
        <RightContainer>
          <PaywallIcon />
        </RightContainer>

        <LmcBackgroundLogo />
      </TopContainer>

      <StyledIframe
        src="https://www.youtube.com/embed/ZM8Dz0b8vi0"
        title="YouTube rostering video"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />

      {showModal && (
        <RotaPaywallModal showPrompt={showModal} setShowPrompt={setShowModal} />
      )}
    </Container>
  )
}

export default RotaPaywall

const Container = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.color.status.popout};
  color: ${({ theme }) => theme.color.neutral.color11};
  padding: 40px 102px;
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 40px;
`

const TopContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 64px;
`

const LeftContainer = styled.div`
  max-width: 500px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1;
`

const RightContainer = styled.div`
  z-index: 1;
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 10px;
`

const UnderlinedText = styled(Text)`
  text-decoration: underline;
`

const CustomCta = styled.div`
  display: flex;
  gap: 4px;

  &:hover {
    cursor: pointer;
  }
`

const StyledIframe = styled.iframe`
  width: 100%;
  aspect-ratio: 16/9;
`
